import { render } from "./SubMenu2.vue?vue&type=template&id=0eae3aa4&ts=true"
import script from "./SubMenu2.vue?vue&type=script&lang=ts"
export * from "./SubMenu2.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__